import Backdrop from '@/components/ui/Backdrop'
import Container from '@/components/ui/Container'
import Eyebrow from '@/components/ui/Eyebrow'

/** The short photo hero at the top of every page except Home. */
export default function PageHero({ eyebrow, title, text, children }) {
  return (
    <section className="relative overflow-hidden text-white">
      <Backdrop
        className="object-[center_30%]"
        overlay="bg-[linear-gradient(180deg,rgba(12,26,51,.75)_0%,rgba(12,26,51,.6)_60%,rgba(12,26,51,.82)_100%)]"
      />
      {/* Room for the fixed header. */}
      <div aria-hidden="true" className="h-24" />
      <Container className="relative pt-14 pb-16">
        <div className="flex max-w-190 flex-col gap-3.5">
          <Eyebrow className="text-sky">{eyebrow}</Eyebrow>
          <h1 className="text-[clamp(38px,4.4vw,56px)] leading-[1.05] tracking-[-0.03em]">
            {title}
          </h1>
          <p className="max-w-140 text-[17px]/[1.6] text-[#dbe4f3]">{text}</p>
          {children}
        </div>
      </Container>
    </section>
  )
}
